import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { MutationKeys, QueryKeys } from "../keys";
import { axiosInterceptor } from "..";
import { ILoginResponse, IResponse } from "../interface";
export interface ILoginCredentials {
  email: string;
  password: string;
  remember: boolean;
}
type IUseLogin = UseMutationOptions<
  ILoginResponse, //IResponse
  AxiosError<IResponse<string>>, //IErrorResponse
  ILoginCredentials
>;

const useLogin = (options?: IUseLogin) => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    ILoginResponse,
    AxiosError<IResponse<string>>,
    ILoginCredentials
  >({
    mutationKey: [MutationKeys.LOGIN],
    ...options,
    mutationFn: async (data: ILoginCredentials) => {
      return (
        await axiosInterceptor.post("b2b-admins/login", {
          ...data,
          email: data.email?.toLowerCase(),
        })
      ).data;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.setQueryData([QueryKeys.Organisation], data.b2bAdmin);
      window.localStorage.setItem("accessToken", data.token.accessToken);
      window.localStorage.setItem("refreshToken", data.token.refreshToken);
      options?.onSuccess?.(data, variables, context);
    },
  });

  return mutation;
};
export default useLogin;
